import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["text", "key"];
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl-next';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { messages } from './messages';
export var InsecureIframeErrorMessage = function InsecureIframeErrorMessage() {
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "error",
    title: intl.formatMessage(messages.title),
    actions: [{
      key: 'support',
      href: 'https://support.atlassian.com/',
      text: intl.formatMessage(messages.contactSupport)
    }].map(function (_ref) {
      var text = _ref.text,
        key = _ref.key,
        restAction = _objectWithoutProperties(_ref, _excluded);
      return /*#__PURE__*/React.createElement(SectionMessageAction, _extends({}, restAction, {
        key: key
      }), text);
    })
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.content));
};
var getIsStorybookEnv = function getIsStorybookEnv() {
  return window.location.pathname.startsWith('/iframe');
};
var getIsSiteEnv = function getIsSiteEnv() {
  return window.location.pathname.startsWith('/examples.html');
};
var getIsCypressEnv = function getIsCypressEnv() {
  return 'Cypress' in window;
};
var getIsDevMode = function getIsDevMode() {
  return window && (getIsStorybookEnv() || getIsSiteEnv() || getIsCypressEnv());
};
var getIsTopFrame = function getIsTopFrame() {
  return self === top;
};
var getIsSameOrigin = function getIsSameOrigin() {
  try {
    var _window$top;
    return ((_window$top = window.top) === null || _window$top === void 0 ? void 0 : _window$top.location.origin) === window.location.origin;
  } catch (_unused) {
    return false;
  }
};
export var isSecureEnvironment = function isSecureEnvironment() {
  return getIsTopFrame() || getIsSameOrigin() || getIsDevMode();
};
export var FrameBreaker = function FrameBreaker(_ref2) {
  var children = _ref2.children,
    disabled = _ref2.disabled;
  return disabled || isSecureEnvironment() ? children : /*#__PURE__*/React.createElement(InsecureIframeErrorMessage, null);
};